import { readSession } from '../lib/auth.js';
export type AssistantPreferenceKind = 'open' | 'thread' | 'tab' | 'width';
export function assistantPreferenceKey(
  kind: AssistantPreferenceKind,
  identity: { tenantId: string; userId: string } | null
): string | null {
  return identity ? `amt.assistant.${kind}:v2:${identity.tenantId}:${identity.userId}` : null;
}
export function currentAssistantPreferenceKey(kind: AssistantPreferenceKind): string | null {
  const session = readSession();
  return assistantPreferenceKey(
    kind,
    session ? { tenantId: session.tenant.id, userId: session.user.id } : null
  );
}
